import { useNavigate } from 'react-router-dom';
import useFilterStore from '../components/streetview/filterStore';
import { SelectedFilters } from '../types/filters.type';

export default function useStreetviewFilterNavigation(): (adaptedFilters: SelectedFilters) => void {
  const { updateFilterStore } = useFilterStore();
  const navigate = useNavigate();

  return (adaptedFilters: SelectedFilters) => {
    updateFilterStore(adaptedFilters);
    navigate('/streetview');
  };
}
